import { render, staticRenderFns } from "./zhuangxiupinzheng.vue?vue&type=template&id=7f0bbead&scoped=true&"
import script from "./zhuangxiupinzheng.vue?vue&type=script&lang=js&"
export * from "./zhuangxiupinzheng.vue?vue&type=script&lang=js&"
import style0 from "./zhuangxiupinzheng.vue?vue&type=style&index=0&id=7f0bbead&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bbead",
  null
  
)

export default component.exports